import { ReleasePolicy } from 'src/shared/types/engine/products';

/** What the customer sees when a product has no setting, in one or two sentences. */
export const defaultBehaviour = (releasePolicy: ReleasePolicy, hasUpsellPage: boolean, isTurnedOnPerProject: boolean): string => {
    if (releasePolicy === ReleasePolicy.MANUAL) {
        return 'The customer sees the upsell page.';
    } else if (hasUpsellPage && isTurnedOnPerProject) {
        return 'Results appear when they are ready, on projects that have the product turned on in their Project Definition. Other sites show the upsell page.';
    } else if (hasUpsellPage) {
        return 'Results appear when they are ready. Sites without them show the upsell page.';
    } else {
        return 'Results appear when they are ready.';
    }
};
